import { render, staticRenderFns } from "./PolicyCard.vue?vue&type=template&id=0e0c70db&"
import script from "./PolicyCard.vue?vue&type=script&lang=js&"
export * from "./PolicyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports